import { createPivotTransformer } from './create-pivot-transformer';

/** Pivot = L. */
export const VOLUME_PIVOT: Record<string, number> = {
  l: 1,
  ml: 0.001,
  m3: 1000,
  in3: 0.0163871,
  ft3: 28.3168,
  bbl: 158.987,
  gal: 3.78541,
};

export const transformVolume = createPivotTransformer(VOLUME_PIVOT);
